import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericSelectMultiple } from '../../components';
import { InputModelWithSource } from '../../models';
import { ValidationMessages } from '../../misc';
import { InputWithSource } from '../../componentTypes';


const MainClassInput: InputWithSource = ({ input }) => (
    <GenericSelectMultiple
        label={input.name}
        input={input}
        message={ValidationMessages.requiredInput(input.name)}
    />
);

MainClassInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(MainClassInput);
